/**
 * Created by root on 11/30/15.
 */

define(function (require) {

    var TableViewController = require('web-agent-framework/TableViewController');

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var SearchInputViewController = require('web-agent-viewControllers/SearchInputViewController');

    window.lpTag = window.lpTag || {};

    var CategoriesViewController = ViewController.extend({
        ControllerName : "CategoriesViewController",
        applicationType : 'CategoriesViewController',
        templateFile : "LP_categories_component.html",

        LPViewMap : {
            searchInputPlaceholder  : ".lpview_search_input_placeholder",
            tablePlaceHolder        : '.lpview_table_placeholder',
            sectionWrapper          : ".lpview_section_wrapper",
            rowsPlaceholder         : ".lpview_items_content",
            mainPlaceholder         : '.lpview_categories_component'
        },

        LPViewClasses : {
            selected : "selected"
        },

        LPClassesMap : {
            search: "search"
        },

        initialize : function (constructorData) {
            var tableConfig = {
                modelController: this.modelController,
                rowsPlaceholder: this.LPViewMap.rowsPlaceholder
            };

            this.tableConfig = lpUtils.mergeObjects(tableConfig, constructorData.tableConfig);
            this.search = constructorData.search;
            this.rowsPlaceholder = this.LPViewMap.rowsPlaceholder;

            this.initView();
        },

        events : function () {

        },
        render : function () {
        }
    });


    CategoriesViewController.prototype.getConfiguration = function () {
        var configuration = {
            templateFile : "LP_categories_component.html",
            rowTemplateFile : "LP_visitor_info_row.html",
            noDataTemplateFile : "LP_recommended_content_no_data.html"
        };
        return configuration;
    };

    CategoriesViewController.prototype.initView = function () {
        if (this.search) {
            this.initSearch();
        }
        this.initTable();
    };

    CategoriesViewController.prototype.initSearch = function () {
        this.searchInputView = new SearchInputViewController({
            inputBlurredWidth : "100%",
            inputFocusedWidth : "100%",
            clearSearchCallback : this.clearSearch,
            context : this
        });
        this.addViewController({viewController : this.searchInputView, target: this.LPViewMap.searchInputPlaceholder});
        this.addClass(this.LPViewMap.mainPlaceholder, this.LPClassesMap.search);

        this.tableConfig.filterView = this.searchInputView && this.searchInputView.searchInput;
    };

    CategoriesViewController.prototype.clearSearch = function () {
        this.categoriesTable.clearFiltering();
    };

    CategoriesViewController.prototype.initTable = function () {
        this.categoriesTable = new TableViewController(this.tableConfig);
        this.addViewController({viewController : this.categoriesTable, target : this.LPViewMap.tablePlaceHolder});
    };

    CategoriesViewController.prototype.updateModelData = function (modelData) {
        if (this.categoriesTable){
            this.categoriesTable.updateModelData(modelData);
        }
    };

    CategoriesViewController.prototype.toggleCategory = function (data, categoryView) {
        var titleView = this.getFirstElement(this.LPViewMap.sectionWrapper, categoryView);
        if (data.expanded) {
            this.addClass(titleView, this.LPViewClasses.selected);
        } else {
            this.removeClass(titleView, this.LPViewClasses.selected);
        }
    };

    CategoriesViewController.prototype.dataRenderer = {
        dataForSection : function (data, sectionIndex) {
            var value = {};
            if (data[sectionIndex].expandedByDefault) {
                value.selected = true;
            }
            return value;
        }
    };

    CategoriesViewController.prototype.dataBinder = {
        rowClicked : function(data, rowView) {
            if (data.isSection) {
                this.toggleCategory(data, rowView);
            }
        }
    };


    return CategoriesViewController;

});
